import React from 'react';
import PropTypes from 'prop-types';

import iconClose from '../../../assets/images/icon-close.svg';
import styles from './Alert.css';

const IPropTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  lines: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const defaultProps = {
  className: '',
  onClose: () => {},
};

const Alert = (props) => {
  const hasHtml = text => /<\/?[a-z][\s\S]*>/i.test(text);

  return (
    <div className={[props.className, styles.container].join(' ')}>
      <button
        className={styles.closeIcon}
        onClick={props.onClose}
      >
        <img src={iconClose} alt="" />
      </button>
      {
        props.lines.map(line => (
          hasHtml(line) ?
            <div dangerouslySetInnerHTML={{ __html: line }} /> :
            <p className={styles.line} key={line}>{line}</p>
        ))
      }
    </div>
  );
};

Alert.propTypes = IPropTypes;
Alert.defaultProps = defaultProps;

export { Alert };



// WEBPACK FOOTER //
// ./src/pages/home/alert/Alert.jsx